import SUPPORTED_BRANDS from './brands';
import SUPPORTED_ENVIRONMENT from './environments';

const isSWA: boolean = import.meta.env.VITE_PORTAL === SUPPORTED_BRANDS.SWA;
const isATP: boolean = import.meta.env.VITE_PORTAL === SUPPORTED_BRANDS.ATP;
const isUnified: boolean = import.meta.env.VITE_PORTAL === SUPPORTED_BRANDS.UNIFIED;

export interface IConfig {
  isProduction: boolean;
  isStaging: boolean;
  isDevelopment: boolean;
  isLocal: boolean;
  currentEnvironment: SUPPORTED_ENVIRONMENT;

  currentBrand: SUPPORTED_BRANDS.SWA | SUPPORTED_BRANDS.ATP;
  isSWA: boolean;
  isATP: boolean;
  isUnified: boolean;

  isODTEnabled: boolean;
  isDedicatedAdviserEnabled: boolean;

  name: string;
  baseURL: string[];
  rollbarApiKey: string;
  tinyMCEKey: string;
  zinreloPartnerId: string;

  facebookLoginAppId: string;
  userPilotAppId: '48gy70h5' | '48gy70h5';

  swaSmartlookApiKey: string;
  atpHotjarApiKey: number;

  monthsToRestrictPaymentDateChange: 12 | 3;

  swaAtpContactSupportTell: '(919) 355-5329' | '1-888-600-3640';
  swaAtpContactSupportEmail: 'support@smarterwithachieve.com' | 'it-notice@achieve-test-prep.com';
  atpCustomerSuccess: string;

  upComingExamSupportLink: {
    link: 'https://smarter-advising.youcanbook.me' | 'https://advisingmeeting.youcanbook.me';
    id: 'ycbmiframeatpcustomersuccessconcierge' | 'ycbmiframeatpcustomersuccessconcierge';
  };

  swaAtpSupportLink: {
    link: '' | 'https://advisingmeeting.youcanbook.me';
    id: '' | 'ycbmiframeatpcustomersuccessconcierge';
  };

  // oneOnOneScheduleURL: string;

  bridgePlan: {
    minCourseToMatchup: number;
    minMatchupAmount: number;
    minMatchupAmount_4: number;
    maxMatchupAmount: number;
  };
}

const settings: IConfig = {
  isProduction: import.meta.env.VITE_ENVIRONMENT === SUPPORTED_ENVIRONMENT.PRODUCTION,
  isStaging: import.meta.env.VITE_ENVIRONMENT === SUPPORTED_ENVIRONMENT.STAGING,
  isDevelopment: import.meta.env.VITE_ENVIRONMENT === SUPPORTED_ENVIRONMENT.DEVELOPMENT,
  isLocal: import.meta.env.VITE_ENVIRONMENT === SUPPORTED_ENVIRONMENT.LOCAL,
  currentEnvironment: (import.meta.env.VITE_ENVIRONMENT as SUPPORTED_ENVIRONMENT) || SUPPORTED_ENVIRONMENT.DEVELOPMENT,

  currentBrand: isSWA ? SUPPORTED_BRANDS.SWA : SUPPORTED_BRANDS.ATP,
  isSWA,
  isATP,
  isUnified,

  isODTEnabled: true,
  isDedicatedAdviserEnabled: true,

  name: import.meta.env.VITE_PORTAL_NAME || '',
  baseURL: [
    import.meta.env.VITE_API_BASE_URL || '',
    import.meta.env.VITE_API_AOD_URL || '',
    import.meta.env.VITE_API_INSTRUCTOR_URL || '',
    import.meta.env.VITE_API_CHECKOUT_URL || '',
  ],
  rollbarApiKey: import.meta.env.VITE_ROLLBAR_API || '',
  tinyMCEKey: import.meta.env.VITE_TINY_MCE_KEY || '',
  zinreloPartnerId: import.meta.env.VITE_ZINRELO || '',

  facebookLoginAppId: import.meta.env.VITE_FB_APP_ID || '',
  userPilotAppId: isSWA ? '48gy70h5' : '48gy70h5',

  swaSmartlookApiKey: '641f3d84ff81fb91e22c5fe464b8c1881d94802f',
  atpHotjarApiKey: isUnified ? 3837969 : 3837965,

  monthsToRestrictPaymentDateChange: isSWA ? 12 : 3,

  swaAtpContactSupportTell: '1-888-600-3640',
  swaAtpContactSupportEmail: 'it-notice@achieve-test-prep.com',
  atpCustomerSuccess: 'customersuccess@achieve-test-prep.com',

  upComingExamSupportLink: {
    link: isSWA ? 'https://smarter-advising.youcanbook.me' : 'https://advisingmeeting.youcanbook.me',
    id: isSWA ? 'ycbmiframeatpcustomersuccessconcierge' : 'ycbmiframeatpcustomersuccessconcierge',
  },

  swaAtpSupportLink: {
    link: isSWA ? '' : 'https://advisingmeeting.youcanbook.me',
    id: isSWA ? '' : 'ycbmiframeatpcustomersuccessconcierge',
  },

  // oneOnOneScheduleURL: 'https://nursing-on-demand-tutoring.youcanbook.me/?noframe=true&skipHeaderFooter=true',

  bridgePlan: {
    minCourseToMatchup: 3,
    minMatchupAmount: 300,
    minMatchupAmount_4: 150,
    maxMatchupAmount: 1000,
  },
};

export default settings;
